import axios from "axios";
import Cookies from "js-cookie";
import store from "@/store";
import { Stream } from "stream-browserify";
import { devStuIndex, tfStuIndex, proStuIndex } from "@/router/config";
import { TOKEN_KEY } from "@/libs/cookieUtil";
import { Buffer } from 'buffer';
window.Buffer = Buffer;

class HttpRequest {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
    this.queue = {};
  }

  // 获取token的统一方法
  getToken() {
    // 1. 优先检查sessionStorage标记
    // const isIframe = sessionStorage.getItem("iframeToken");

    // // 2. 根据场景获取token
    // const token = isIframe
    //   ? localStorage.getItem("iframeToken")
    //   : Cookies.get(TOKEN_KEY);

    const token = ''

    return token;
  }

  getInsideConfig() {
    return {
      baseURL: this.baseUrl
    };
  }

  destroy(url) {
    delete this.queue[url];
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }

  interceptors(instance, url) {
    // 请求拦截器
    instance.interceptors.request.use(
      config => {
        // 自动添加token到headers
        // const token = this.getToken();
        // if (token) {
        //   config.headers['Authorization'] = `Bearer ${token}`;
        // }

        if (!Object.keys(this.queue).length) {
          // Spin.show()
        }
        this.queue[url] = true;
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );

    // 响应拦截器
    instance.interceptors.response.use(
      res => {
        this.destroy(url);
        const { data, status } = res;

        if (data.code === -6) { // token失效处理
          this.handleTokenExpired();
        }
        return { data, status };
      },
      error => {
        this.destroy(url);
        if (error.response && error.response.status === 401) {
          this.handleTokenExpired();
        }
        return Promise.reject(error);
      }
    );
  }

  // token过期统一处理方法
  handleTokenExpired() {
    const isIframe = sessionStorage.getItem("iframeSrc");
    if (!isIframe) {
      store.dispatch("logout").then(() => {
        localStorage.setItem("clearStore", true);
        if (process.env.NODE_ENV == "alpha") {
          window.location.href = window.location.href.startsWith("https")
            ? tfStuIndex
            : devStuIndex;
        } else if (process.env.NODE_ENV == "production") {
          window.location.href = proStuIndex;
        }
      });
    }
  }

  request(options, config = {}) {
    const instance = axios.create({
      transformRequest: [
        (data, headers) => {
          if (!data) data = { client: 4 };

          console.log('data', data)

          // 统一处理不同数据类型的token添加
          const token = this.getToken();
          const uid = store.state.user?.userId;

          if (data instanceof FormData ||
            data instanceof ArrayBuffer ||
            data instanceof Buffer ||
            data instanceof Stream ||
            data instanceof File ||
            data instanceof Blob) {

            data.append("client", 4);
            if (!data.has("token")) {
              const isIframe = sessionStorage.getItem("iframeSrc");
              if (isIframe) {
                data.append("token", localStorage.getItem("iframeToken"));
              } else {
                data.append("token", Cookies.get(TOKEN_KEY));
              }
              data.append("uid", store.state.user.userId);
            }
            // if (token && !data.has("token")) data.append("token", token);
            // if (uid) data.append("uid", uid);
            return data;

          } else if (data instanceof URLSearchParams) {

            data.append("client", 4);
            if (token && !data.has("token")) data.append("token", token);
            if (uid) data.append("uid", uid);
            headers["Content-Type"] = "application/x-www-form-urlencoded;charset=utf-8";
            return data.toString();

          } else if (typeof data === 'object') {

            return Object.entries({
              ...data,
              client: 4,
              ...(token ? { token } : {}),
              ...(uid ? { uid } : {})
            })
              .map(([name, value]) => `${name}=${encodeURIComponent(value)}`)
              .join("&");

          }
          return data;
        }
      ],
      ...config
    });

    options = Object.assign(this.getInsideConfig(), options);
    this.interceptors(instance, options.url);
    return instance(options);
  }
}

export default HttpRequest;